import { render } from "./tarjetas.vue?vue&type=template&id=89ee0e8c&scoped=true"
import script from "./tarjetas.vue?vue&type=script&lang=js"
export * from "./tarjetas.vue?vue&type=script&lang=js"

import "./tarjetas.vue?vue&type=style&index=0&id=89ee0e8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ee0e8c"]])

export default __exports__